<div #card class="se-history-card" (click)="onCardSelected()" [class.se-card-selected]="item.selected">

    <!--icona per warning similarità-->
    @if(item.isSimilar) {
    <div class="se-side-corner-icon se-side-left-icon">
        <mat-icon style="width: 16px; height: 15px;" matTooltip="{{'PatientSimilarityWarning' | translate}}">priority_high</mat-icon>
    </div>
    }

    <!--Parametri Monitoraggio (H&S)-->
    @if(item.isMonitoring) {
    <button mat-icon-button
            class="se-button-no-ripple se-side-corner-icon se-side-right-icon"
            (click)='openParameters($event)'
            matTooltip="{{'Parameters' | translate}}">
        <mat-icon style="width: 15px; height: 15px;" class="se-side-small-icon material-icons-outlined">article</mat-icon>
    </button>
    }


    <div class="se-history-panel" (click)="toggleExpanded()">
        <!-- Data - Descrizione-->
        <div style="display:flex;flex-direction:row">
            <span class="se-history-label se-history-multi-value">{{'Date' | translate}}</span>
            @if(!!item.description) {
            <span class="se-history-label se-history-multi-value se-history-space">{{'Description' | translate}}</span>
            }
        </div>
        <div style="display:flex;flex-direction:row">
            <span class="se-history-value se-history-multi-value" [ngClass]="{'se-history-value-truncated': !isExpanded}" seEllipsisWithTooltip>{{item.dateString}}</span>
            @if(!!item.description) {
            <span class="se-history-value se-history-multi-value se-history-space" [ngClass]="{'se-history-value-truncated': !isExpanded}" seEllipsisWithTooltip>{{item.description}}</span>
            }
        </div>

        @if(isExpanded) {
        <div [@expansionAnimation] class="se-history-expansion-panel">
            <!-- Data Referto - Medico Refertatore-->
            <div style="display:flex;flex-direction:row">
                @if(!!item.reportDateString) {
                <span class="se-history-label se-history-multi-value">{{'ReportDate' | translate}}</span>
                }
                @if(!!item.referringPhysician) {
                <span class="se-history-label se-history-multi-value" [ngClass]="{'se-history-space': !!item.reportDateString}" seEllipsisWithTooltip>{{'ReferringPhysician' | translate}}</span>
                }
            </div>
            <div style="display:flex;flex-direction:row">
                @if(!!item.reportDateString) {
                <span class="se-history-value se-history-multi-value" seEllipsisWithTooltip>{{item.reportDateString}}</span>
                }
                @if(!!item.referringPhysician) {
                <span class="se-history-value se-history-multi-value" [ngClass]="{'se-history-space': !!item.reportDateString}" seEllipsisWithTooltip>{{item.referringPhysician}}</span>
                }
            </div>

            <!-- Provenienza - Unità operativa -->
            <div style="display:flex;flex-direction:row">
                @if(!!item.provenance) {
                <span class="se-history-label se-history-multi-value">{{'Provenance' | translate}}</span>
                }
                @if(!!item.businessUnit) {
                <span class="se-history-label se-history-multi-value" [ngClass]="{'se-history-space': !!item.provenance}">{{'BusinessUnit' | translate}}</span>
                }
            </div>
            <div style="display:flex;flex-direction:row">
                @if(!!item.provenance) {
                <span class="se-history-value se-history-multi-value" seEllipsisWithTooltip>{{item.provenance}}</span>
                }
                @if(!!item.businessUnit) {
                <span class="se-history-value se-history-multi-value" [ngClass]="{'se-history-space': !!item.provenance}" seEllipsisWithTooltip>{{item.businessUnit}}</span>
                }
            </div>

            <!-- Stato -->
            <div style="display:flex;flex-direction:row">
                @if(!!item.status){
                <span class="se-history-label se-history-multi-value">{{'Status' | translate}}</span>
                }
            </div>
            <div style="display:flex;flex-direction:row">
                @if(!!item.status){
                <span class="se-history-value se-history-multi-value" seEllipsisWithTooltip>{{item.status}}</span>
                }
            </div>

            <div style="display:flex;flex-direction:row">
                @if(!!item.report) {
                <span class="se-history-label">{{'Report' | translate}}</span>
                }
                <!-- Importa conclusioni - visibile solo dentro le cp -->
                @if(!!item.report && isCp) {
                <button mat-icon-button
                        class="se-button-no-ripple copy-button"
                        (click)='copyReport($event, item)'
                        [style.display]="(item.report) ? 'block' : 'none'"
                        matTooltip="{{'Import' | translate}} {{'Report' | translate}}">
                    <mat-icon style="font-size: 22px!important;" class="se-side-small-icon icon-color">content_copy</mat-icon>
                </button>
                }

            </div>
            <div style="display:flex;flex-direction:row; width: 100%">
                @if(!!item.report) {
                <span class="se-history-value"
                      (click)="$event.stopPropagation()"
                      style="user-select: text; cursor: default; width: 100%">{{item.report}}</span>
                }
            </div>
        </div>
        }

    </div>

    <div class="se-history-footer-panel" [class.se-history-footer-selected-panel]="item.selected">

        <!-- Referto PDF -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.reportDate && item.reportKey) ? 'block' : 'none'"
                (click)='openPdf($event)'
                matTooltip="PDF">
            <mat-icon style="font-size: 22px!important;" class="se-side-small-icon material-icons-outlined icon-color">picture_as_pdf</mat-icon>
        </button>
        <!-- Immagini -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.imagesAvailability) && isAuthorized ? 'block' : 'none'"
                (click)='openImagesByEprEvent($event)'
                matTooltip="{{'Images' | translate}}">
            <mat-icon style="font-size: 22px!important;" class="se-side-small-icon material-icons-outlined icon-color">collections</mat-icon>
        </button>

    </div>
</div>
